import { Tab, Tabs, tabsClasses, useMediaQuery } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WithPreloader from '../../HOC/WithPreloader'
import UserCardHelper from '../../helpers/userCard.helper'
import { clearUserCardState, getUserCard } from '../../redux/actions/userCard.action'
import Select from '../../UI/Select/Select'
import CardHeader from './CardHeader/CardHeader'
import Certificates from './Certificates/Certificates'
import Colleagues from './Colleagues/Colleagues'
import ContactInfo from './ContactInfo/ContactInfo'
import Education from './Education/Education'
import Experience from './Experience/Experience'
import Licenses from './Licenses/Licenses'
import Passports from './Passports/Passports'
import Reviews from './Reviews/Reviews'
import SizeInformation from './SizeInformation/SizeInformation'
import styles from './UserCard.module.scss'
import { UserPreloaderDoubleColumns as preloaderDoubleColumns } from './UserPreloaderItems/UserPreloaderDoubleColumns/UserPreloaderDoubleColumns.jsx'
import { UserPreloaderDoubleItem as preloaderDoubleItem } from './UserPreloaderItems/UserPreloaderDoubleItem/UserPreloaderDoubleItem'
import VideoResume from './VideoResume/VideoResume'
import Visas from './Visas/Visas'
import './slider-style.scss'

const navigation = [
  { id: 0, title: 'Contact Info', component: ContactInfo, preloader: preloaderDoubleItem },
  { id: 1, title: 'Education', component: Education, preloader: preloaderDoubleItem },
  { id: 2, title: 'Work Experience', component: Experience, preloader: preloaderDoubleColumns },
  { id: 3, title: 'Passports', component: Passports, preloader: preloaderDoubleItem },
  { id: 4, title: 'Visas', component: Visas, preloader: preloaderDoubleItem },
  { id: 5, title: 'Licenses', component: Licenses, preloader: preloaderDoubleColumns },
  { id: 6, title: 'Certificates', component: Certificates, preloader: preloaderDoubleItem },
  { id: 7, title: 'Size information', component: SizeInformation, preloader: preloaderDoubleItem },
  { id: 8, title: 'Reviews', component: Reviews, preloader: preloaderDoubleItem },
  { id: 9, title: 'Video Resume', component: VideoResume },
  { id: 10, title: 'Colleagues', component: Colleagues },
]

export default function UserCard() {
  const dispatch = useDispatch()

  const ref = useRef()
  const isMobileNav = useMediaQuery('(max-width:767.98px)')
  const [currentTab, setCurrentTab] = useState('Contact Info')
  const data = useSelector(({ userCard }) => userCard)
  const { loading, loadingGeneral } = useSelector(({ userCard }) => userCard)
  const [value, setValue] = React.useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    setCurrentTab(navigation.find((item) => item.id === newValue).title)
  }

  const handleSelectChange = (name, selected) => {
    if (!selected || selected.id === null || selected.id === undefined) return

    setValue(selected.id)
    setCurrentTab(navigation.find((item) => item.id === selected.id)?.title || selected.name)
  }

  React.useEffect(() => {
    dispatch(getUserCard('general'))
    return () => {
      dispatch(clearUserCardState())
    }
  }, [dispatch])

  useEffect(() => dispatch(getUserCard(UserCardHelper.transformTitleToQueryParameter(currentTab))), [
    currentTab,
    dispatch,
  ])

  const { component, preloader } = navigation.find((r) => r.title === currentTab)

  return (
    <section className={styles.user_card}>
      <div className={styles.previewNote}>
        <h4 className={styles.previewTitle}>Profile preview</h4>
        <p className={styles.previewText}>This is how companies see your profile.</p>
      </div>
      <div className={styles.card} ref={ref}>
        {data && <CardHeader generalUserCardInfo={data.general} loading={loadingGeneral} />}
        <div className={styles.nav}>
          {isMobileNav ? (
            <Select
              name='user_card_section'
              id={value}
              selectedItem={navigation.find((item) => item.id === value)?.title}
              items={navigation.map((item) => ({ id: item.id, name: item.title }))}
              defaultName=''
              onClick={handleSelectChange}
              className={styles.userCardNavSelect}
            />
          ) : (
            <Tabs
              value={value}
              onChange={handleChange}
              variant={'scrollable'}
              indicatorColor='#222'
              textColor='#222'
              sx={{
                alignItems: 'center',
                gap: '8px',
                [`& .MuiTab-root`]: {
                  fontFamily: 'Montserrat, sans-serif',
                  padding: '8px 24px',
                  letterSpacing: 'normal',
                  lineHeight: 'normal',
                  minHeight: '17px',
                  textTransform: 'capitalize',
                  // color: '#222',
                },
                [`& .${tabsClasses.scroller}`]: {
                  order: '1',
                  borderBottom: '1px solid #DFF0EB',
                },
                [`& .${tabsClasses.scrollButtons}`]: {
                  order: 2,
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  backgroundColor: '#43927C',
                  color: '#fff',
                  '&.Mui-disabled': { opacity: 0.3 },
                },
                [`& .Mui-selected`]: {
                  fontWeight: 600,
                },
                [`& .${tabsClasses.indicator}`]: {
                  backgroundColor: '#43927C',
                  height: '2px',
                  zIndex: 1,
                },
              }}
            >
              {navigation.map((item) => {
                return <Tab key={item.id} label={item.title} value={item.id} />
              })}
            </Tabs>
          )}
        </div>
        <div className={styles.content}>
          <WithPreloader size={50} isActive={loading} userCardData={data} component={component} preloader={preloader} />
        </div>
      </div>
    </section>
  )
}
